import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Entertainment({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M2.66667 4.66626H16.0001V5.99961H3.33335V8.73298C4.85486 9.04183 6.00004 10.387 6.00004 11.9997C6.00004 13.6123 4.85486 14.9575 3.33335 15.2664V17.9997H16.0001V19.3331H2.66667C2.29848 19.3331 2 19.0346 2 18.6664V14.6664C2 14.2982 2.29848 13.9997 2.66667 13.9997C3.77125 13.9997 4.66669 13.1042 4.66669 11.9997C4.66669 10.8951 3.77125 9.99965 2.66667 9.99965C2.29848 9.99965 2 9.70117 2 9.33297V5.33293C2 4.96474 2.29848 4.66626 2.66667 4.66626Z"
        fill={iconColor}
      />
      <Path
        d="M20.6669 17.9997H17.3335V19.3331H21.3335C21.7017 19.3331 22.0002 19.0346 22.0002 18.6664V14.6664C22.0002 14.2982 21.7017 13.9997 21.3335 13.9997C20.2289 13.9997 19.3335 13.1042 19.3335 11.9997C19.3335 10.8951 20.2289 9.99965 21.3335 9.99965C21.7017 9.99965 22.0002 9.70117 22.0002 9.33297V5.33293C22.0002 4.96474 21.7017 4.66626 21.3335 4.66626H17.3335V5.99961H20.6669V8.73298C19.1453 9.04183 18.0002 10.387 18.0002 11.9997C18.0002 13.6123 19.1453 14.9575 20.6669 15.2664V17.9997Z"
        fill={iconColor}
      />
      <Path
        d="M11.8416 8.48747C11.8915 8.33392 12.1087 8.33392 12.1586 8.48747L12.8607 10.6484C12.8831 10.7171 12.9471 10.7636 13.0193 10.7636H15.2914C15.4529 10.7636 15.52 10.9702 15.3894 11.0651L13.5512 12.4006C13.4928 12.4431 13.4683 12.5183 13.4906 12.587L14.1928 14.7479C14.2426 14.9015 14.0669 15.0292 13.9363 14.9343L12.0981 13.5987C12.0397 13.5563 11.9606 13.5563 11.9021 13.5987L10.0639 14.9343C9.9333 15.0292 9.75756 14.9015 9.80745 14.7479L10.5096 12.587C10.5319 12.5183 10.5075 12.4431 10.449 12.4006L8.61082 11.0651C8.4802 10.9702 8.54733 10.7636 8.70879 10.7636H10.9809C11.0532 10.7636 11.1171 10.7171 11.1395 10.6484L11.8416 8.48747Z"
        fill={iconColor}
      />
    </Svg>
  );
}
